import { render, staticRenderFns } from "./IPQCUser.vue?vue&type=template&id=dd842d82&scoped=true"
import script from "./IPQCUser.vue?vue&type=script&lang=js"
export * from "./IPQCUser.vue?vue&type=script&lang=js"
import style0 from "./IPQCUser.vue?vue&type=style&index=0&id=dd842d82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd842d82",
  null
  
)

export default component.exports